export default "__VITE_ASSET__7VjiCWT9__"